import { createSearchParams, useParams } from 'react-router-dom'
import { deleteRequest, getRequest, postRequest } from '../../../services/base'
import Button from '../../common/Button'
import InputText from '../../common/InputText'
import LinkWithStatus from '../../common/LinkWithStatus'
import { useContext, useEffect, useState } from 'react'
import InlineConnectionRow from './InlineConnectionRow'
import {
  InlineConnectionContext,
  SET_INLINE_CONNECTION_DATA,
  SET_SELECTED_INLINE_CONNECTION_DATA,
  SET_SHOW_HIDE_INLINE_POPUP,
} from './context/context'
import NoRecordsFound from '../../common/NoRecordsFound'
import Pagination from '../../common/Pagination'
import { NavContext } from '../../../context/global_context'
import InlinesConnectionsFormModal from './form'
import { getLocalStorageData } from '../../../utils/LocalStorageAccess'
import DownloadInlines from './DownloadInlines'

const Inlines = () => {
  let { vehicle } = useParams()
  const [state, dispatch] = useContext(InlineConnectionContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({})
  const vehicle_redirect_url = getLocalStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getLocalStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    getInlineConnectionsData()

    navDispatch({
      type: 'header',
      data: {
        header: 'Inline Connections',
        sub_header: 'You can configure inline connections from here.',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])
  const getInlineConnectionsData = async (url = null) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Inline Connections Data',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      url
        ? url
        : `/api/inline_connection/?vehicle=${vehicle}&search=${searchValue}`
    )
    dispatch({
      type: SET_INLINE_CONNECTION_DATA,
      data: res.results,
    })
    setPagination(res.pagination)
    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deleteInlineConnections = async (inline_connection_id) => {
    if (window.confirm('Are you sure to delete Inline Connection') == true) {
      let res = await deleteRequest(
        `/api/inline_connection/${inline_connection_id}/?vehicle=${vehicle}`
      )
      getInlineConnectionsData(null)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'Inline Connection Successfully deleted!',
        },
      })
    }
  }

  return (
    <div className="w-full">
      <InlinesConnectionsFormModal
        onSave={() => {
          dispatch({
            type: SET_SHOW_HIDE_INLINE_POPUP,
            data: false,
          })
        }}
        getListData={() => getInlineConnectionsData()}
      />

      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div
          className={`flex space-x-5 justify-between content-center items-center`}
        >
          <div className="flex items-center w-1/2">
            <div className="flex items-center w-full">
              <InputText
                name="seach_value"
                placeholder={`Seach Inline Connections`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="text"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
              <Button
                className={`cursor-pointer btn my-4 justify-end`}
                text={`Search`}
                onClick={() => {
                  getInlineConnectionsData()
                }}
              />
            </div>
          </div>
          <div className="w-6/12 flex font-light text-center space-x-5 justify-end content-center items-center">
            <DownloadInlines />
            <LinkWithStatus
              href={`/administration/system/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Inlines"
              onClickFunc={() => {
                dispatch({
                  type: SET_SHOW_HIDE_INLINE_POPUP,
                  data: true,
                })
              }}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-4/12 items-center">From Connector</div>
          <div className="flex w-4/12 pl-6 items-center">To Connector</div>
          <div className="flex w-2/12 pl-6 items-center">Prefix</div>
          <div className="flex w-2/12 pl-6 items-center">Suffix</div>
          <div className="flex w-1/12 pl-6 items-center"></div>
        </div>
      </div>

      {state?.data?.map((inline_connection, index) => {
        return (
          <InlineConnectionRow
            {...inline_connection}
            onDelete={() => {
              deleteInlineConnections(inline_connection.id)
            }}
            key={`inline-connection-${index}`}
            onShowDetails={() => {
              dispatch({
                type: SET_SELECTED_INLINE_CONNECTION_DATA,
                data: { ...inline_connection, index: index },
              })
            }}
          />
        )
      })}

      {state?.data?.length < 1 && (
        <NoRecordsFound
          caption={'Inline Connections not found'}
          loading={false}
        />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getInlineConnectionsData(e)
          }}
          onClickPrev={(e) => {
            getInlineConnectionsData(e)
          }}
        />
      </div>
    </div>
  )
}

export default Inlines
